import { Link } from 'react-router-dom';
import { hotMangas } from '@/mocks/manga';

const cardBgColors = [
  'bg-[#fce4d6]',
  'bg-[#d9e8d4]',
  'bg-[#e8e4d9]',
  'bg-[#f5e1c8]',
];

export default function HotMangaSection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="mb-8">
        <p className="text-xs text-foreground-500 uppercase tracking-widest mb-2">
          HOT PICKS
        </p>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
          热门韩漫
          <span className="font-heading italic text-accent-500 ml-2">精选推荐</span>
        </h2>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {hotMangas.map((manga, index) => (
          <Link
            key={manga.id}
            to={`/comic/${manga.id}`}
            className="group block rounded-2xl overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
            data-product-shop=""
          >
            <div className={`${cardBgColors[index % 4]} aspect-[3/4] relative overflow-hidden`}>
              <img
                src={manga.coverImage}
                alt={manga.title}
                title={`${manga.title} - 歪歪漫画网热门韩国漫画`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute top-3 left-3">
                <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                  manga.status === '连载中'
                    ? 'bg-accent-500/90 text-background-50'
                    : 'bg-foreground-800/80 text-background-50'
                }`}>
                  {manga.status}
                </span>
              </div>
              <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm rounded-full px-2 py-0.5">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span className="text-xs font-semibold text-foreground-800">{manga.rating}</span>
              </div>
            </div>
            <div className="bg-background-50 px-1 pt-3 pb-1">
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {manga.author} · 共{manga.chapters}话
              </p>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          查看全部热门漫画
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}